import React from "react";
import { ExclamationCircleTwoTone } from "@ant-design/icons";
import { Popconfirm } from "antd";

const ConfirmDialog = ({ children, placement = "top", title, onConfirm, ...props }) => (
  <Popconfirm
    placement={placement}
    title={title}
    onConfirm={onConfirm}
    okText="Yes"
    cancelText="No"
    icon={<ExclamationCircleTwoTone />}
    overlayStyle={{zIndex: 2000}}
    {...props}
  >
    {children}
  </Popconfirm>
);

export default ConfirmDialog;
